export const DEBUG_MENU = "debug_menu"
